import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCogHandGive1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "cog-hand-give-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .5,
			y1: 15.501,
			x2: .5,
			y2: 23.501
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.5,22.5a3,3,0,0,0-3-3H8.75a3,3,0,0,0-3-3H.5v6Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.75,
			y1: 19.501,
			x2: 9.5,
			y2: 19.501
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 17.75,
			cy: 6.97,
			r: 1.437
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.971,1.409,19.4,2.8a.953.953,0,0,0,1.124.653l1.412-.328a1.283,1.283,0,0,1,1.221,2.126l-.988,1.065a.96.96,0,0,0,0,1.3l.988,1.065a1.283,1.283,0,0,1-1.221,2.126l-1.412-.327a.951.951,0,0,0-1.124.653l-.424,1.392a1.275,1.275,0,0,1-2.442,0l-.424-1.392a.951.951,0,0,0-1.124-.653l-1.412.327a1.283,1.283,0,0,1-1.221-2.126l.988-1.065a.96.96,0,0,0,0-1.3l-.988-1.065a1.283,1.283,0,0,1,1.221-2.126l1.412.328A.953.953,0,0,0,16.105,2.8l.424-1.392A1.275,1.275,0,0,1,18.971,1.409Z"
		})
	]
});
export default SvgCogHandGive1;
